import type { Awaitable } from '@ipfabric/ui-components/utils/types/Awaitable';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';
import { addHistoryItem } from 'utils/history/CallbackHistory';

export interface PerformUndoableActionCommand {
  /**
   * Skip initial call to redo() for actions that perform the action differently
   * for the first time.
   *
   * Normally, the undoable action is immediately performed by calling redo().
   * However, in some cases this may not be desired. For example, when applying
   * a layouting algorithm on a graph, we may get a different result every time,
   * so we call it only when initially performing the command, then undo/redo
   * just applies old and new positions.
   */
  skipInitialRedo?: boolean;
  undo: () => Awaitable<void>;
  redo: () => Awaitable<void>;
}

export const performUndoableAction: GraphCommandFactory<
  PerformUndoableActionCommand
> = (cmdContext) => async (command) => {
  if (!command.skipInitialRedo) {
    await command.redo();
  }
  cmdContext.updateState((draft) => {
    draft.history = addHistoryItem(draft.history, command);
  });
};
